import { useEffect, useState } from "react";
import "./FilterBar.css";

const EMERGENCY_SQUAWKS = ["7500", "7600", "7700"];
const METRES_TO_FEET = 3.28084;

const STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "airborne", label: "Airborne" },
  { value: "ground", label: "On ground" },
];

function isEmergency(ac) {
  return EMERGENCY_SQUAWKS.includes(String(ac.squawk).trim());
}

export default function FilterBar({ onChange }) {
  const [status, setStatus] = useState("all");
  const [minAltitudeFt, setMinAltitudeFt] = useState(0);
  const [emergencyOnly, setEmergencyOnly] = useState(false);

  useEffect(() => {
    const predicate = (ac) => {
      if (status === "airborne" && ac.onGround) return false;
      if (status === "ground" && !ac.onGround) return false;

      if (minAltitudeFt > 0) {
        const feet = (ac.baroAltitude ?? 0) * METRES_TO_FEET;
        if (feet < minAltitudeFt) return false;
      }

      if (emergencyOnly && !isEmergency(ac)) return false;

      return true;
    };

    onChange(predicate);
  }, [status, minAltitudeFt, emergencyOnly, onChange]);

  const altitudeValueText = `${minAltitudeFt.toLocaleString()} feet`;

  return (
    <section className="filter-bar" aria-label="Filter aircraft">
      <div className="filter-group" role="group" aria-labelledby="filter-status-label">
        <span className="filter-label" id="filter-status-label">
          Status
        </span>
        <div className="segmented">
          {STATUS_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={status === opt.value ? "segment active" : "segment"}
              aria-pressed={status === opt.value}
              onClick={() => setStatus(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="filter-group">
        <label className="filter-label" htmlFor="filter-min-altitude">
          Min altitude · {altitudeValueText}
        </label>
        <input
          id="filter-min-altitude"
          className="filter-range"
          type="range"
          min={0}
          max={45000}
          step={1000}
          value={minAltitudeFt}
          aria-valuetext={altitudeValueText}
          onChange={(e) => setMinAltitudeFt(Number(e.target.value))}
        />
      </div>

      <div className="filter-group filter-group-inline">
        <input
          id="filter-emergency-only"
          className="filter-checkbox"
          type="checkbox"
          checked={emergencyOnly}
          onChange={(e) => setEmergencyOnly(e.target.checked)}
        />
        <label className="filter-label" htmlFor="filter-emergency-only">
          Only emergencies
        </label>
      </div>
    </section>
  );
}
